export default ($axios) => ({
  fetchInvoices(query) {
    return $axios.get('/admin/invoices', { params: query }).then((response) => response.data);
  },
});
